export const version = "bytes/5.2.0";
